import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import "../../styles/InfoCard.css";

const PassWordInitialize = ({ Server_IP, token, userId, userEmail }) => {
  const { managerEmail } = useAuth();
  const [tempPassword, setTempPassword] = useState("");
  const digit = 6;

  // 임의 비밀번호 생성 함수
  const generateRandomPassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < digit; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  // 비밀번호 저장 요청 함수 (DB 업데이트)
  const updatePassword = async (newPassword) => {
    try {
      await axios.post(
        `${Server_IP}/api/updateClientPassword/`,
        { clientCode: userId, newPassword: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return true;
    } catch (error) {
      console.error("비밀번호 업데이트 실패:", error);
      return false;
    }
  };

  // 비밀번호 생성 버튼 클릭 핸들러
  const handleTempPasswordClick = () => {
    setTempPassword(generateRandomPassword());
  };

  // 저장 및 메일발송 버튼 클릭 핸들러
  const handleSaveMailPasswordClick = async () => {
    if (!tempPassword) {
      alert("먼저 임의 비밀번호를 생성해주세요.");
      return; 
    }

    // 전송 대상 이메일 자동 결정
    const isTestMode = 
      process.env.REACT_APP_PORT?.startsWith("8") || 
      window.location.port.startsWith("8");
    
    let targetEmail = isTestMode ? managerEmail : userEmail;

    if (!targetEmail) {
      alert(isTestMode ? "[테스트 모드] 관리자 이메일 정보가 없습니다." : "거래처 이메일 정보가 없습니다.");
      return;
    }

    const success = await updatePassword(tempPassword);
    if (success) {
      try {
        await axios.post(
          `${Server_IP}/api/sendPasswordMail/`,
          {
            email: targetEmail, 
            clientCode: userId,
            password: tempPassword,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert(`비밀번호가 저장되고 메일이 전송되었습니다.`);
      } catch (error) {
        console.error("메일 발송 실패:", error);
        alert(`메일 발송 중 오류가 발생했습니다.`);
      }
    } else {
      alert("비밀번호 저장에 실패했습니다.");
    }
  };

  return (
    <div className="info-card modern" style={{ marginTop: "16px" }}>
      <div className="client-info">
        <div className="input-row">
          <label className="input-label">비번초기화</label>
          <input
            className="input-box query-input-narrow"
            type="text"
            placeholder="비밀번호입력"
            value={tempPassword}
            readOnly
          />
        </div>
      </div>
      <div className="bottom-bar">
        <button className="action-btn" onClick={handleTempPasswordClick}>
          임의 비밀번호생성
        </button>
        <button className="action-btn" onClick={handleSaveMailPasswordClick}>
          저장 및 메일발송
        </button>
      </div>
    </div>
  );
};

export default PassWordInitialize;
